/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Suggestions_Welcome_9Inputs */

const es_chat_suggestions_welcome_9 = /** @type {(inputs: Chat_Suggestions_Welcome_9Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Podés comenzar cuando quieras, ${i?.name}.`)
};

const en_chat_suggestions_welcome_9 = /** @type {(inputs: Chat_Suggestions_Welcome_9Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You can start whenever you're ready, ${i?.name}.`)
};

/**
* | output |
* | --- |
* | "You can start whenever you're ready, {name}." |
*
* @param {Chat_Suggestions_Welcome_9Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_welcome_9 = /** @type {((inputs: Chat_Suggestions_Welcome_9Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Welcome_9Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_welcome_9(inputs)
	return en_chat_suggestions_welcome_9(inputs)
});
export { chat_suggestions_welcome_9 as "chat.suggestions.welcome_9" }